
import {
    defineComponent, ref, reactive, onBeforeUnmount
} from 'vue';
import '@/assets/less/index.less';
import {
    account as accountRequestData, accountType, community, communityType
} from '@/data';
import { horizontal, vertical } from '@/components/common/nav/index';
import textPopover from '@/components/common/text-popover/index.vue';
import selectList, { SelectItem } from '@/components/common/select-list';
import passwordDialog from '@/components/view/common/dialog/password-change';
import billingDialog from '@/components/view/common/dialog/billing';
import documentDialog from '@/components/view/common/dialog/document';
import linkSiteDialog from '@/components/view/common/dialog/link-site';
import linkSucceedDialog from '@/components/view/common/dialog/link-site/link-succeed-dialog.vue';
import router, { propertyBaseRouter, propertySubRouter } from '@/router';
import goBackLogin from '@/router/back-login';
import setLang from '@/methods/setLang';
import ChangeTextByScene from '@/methods/setText';
import { communityForPmApi, pmCommonApi } from '@/api';
import ImportFaceTip from '@/components/view/pm/import-face-tip/index.vue';
import importFaceTipUtil from '@/components/view/pm/import-face-tip/importFaceTipUtil';
import emergencyActionDialog from '@/views/pm/alarm-records/components/emergency-action-dialog.vue';
import eventBus from '@/util/use-event-bus/global-event-bus';
import initWebSocket from '@/components/view/pm/alarm-dialog/composables/property-alarm-ws';
import { initPoll } from '@/components/view/pm/alarm-dialog/composables/property-alarm-Polling';

import initProcess from '@/components/view/pm/alarm-dialog';
import useGetTokenStatus from '@/util/use-get-token-status';
import {
    getUserOperaData, getMenuList, activeCommunity,
    checkNameForProject, controlPop
} from './util';

export default defineComponent({
    components: {
        horizontal,
        vertical,
        textPopover,
        selectList,
        passwordDialog,
        billingDialog,
        documentDialog,
        linkSiteDialog,
        linkSucceedDialog,
        ImportFaceTip,
        emergencyActionDialog
    },
    setup() {
        const {
            isShowImportFaceTip, dealImportDetails, closeImportFaceTip, initImportFaceTipData, getImportDetails,
            getImportResidentDetail
        } = importFaceTipUtil();

        onBeforeUnmount(() => {
            initImportFaceTipData();
            eventBus.emit('logOut');
            localStorage.setItem('token', '');
        });

        // 告警信息
        initProcess(
            (wsUrl: string) => {
                initWebSocket(eventBus, wsUrl);
            },
            () => {
                initPoll();
            }
        );

        useGetTokenStatus();

        const {
            hideAllPop,
            hideOtherPop,
            controlPopVal
        } = controlPop();
        setLang();
        const menus = ref(getMenuList(1));
        const { userOperaList, fileList } = getUserOperaData();

        const communityList: Array<SelectItem & { isNew: string }> = reactive([]);
        communityForPmApi.getPropertyCommunityList((data: Array<accountType.GetPropertyCommunityItem>) => {
            // 6.3做办公社区比较是否有重名，重名加提示
            const uniqueData = checkNameForProject(data);
            uniqueData.forEach((item) => {
                communityList.push({
                    key: item.ID.toString(),
                    label: item.Location,
                    isNew: item.IsNew
                });
            });

            const communityID = localStorage.getItem('communityID');
            let haveCommunity = false;
            uniqueData.forEach((item) => {
                if (item.ID === communityID) {
                    haveCommunity = true;
                    activeCommunity.ID = item.ID;
                    activeCommunity.label = item.Location;
                }
            });

            if (!haveCommunity) {
                localStorage.setItem('communityID', uniqueData[0].ID.toString());
                activeCommunity.ID = uniqueData[0].ID;
                activeCommunity.label = uniqueData[0].Location;
            }
        });

        const getProjectDetail = () => {
            communityForPmApi.getPMCommunityDetail((res: communityType.CommunityDetail) => {
                community.IsEncryptPin.value = res.IsEncryptPin;
                community.IsEnableLandline.value = res.EnableLandline;
                community.customizeForm.value = res.CustomizeForm;
                community.LimitQRCode.value = res.LimitQRCode;
                // 6.5第三方设备需求
                community.hasThirdPartyDevice.value = res.ThirdPartyDevices === 1;
                // 6.5.2 sdk二期是否含有中控设备
                community.hasControlDevice.value = res.ControlDevices === 1;
                // 7.0 pm区分办公、社区角色
                community.ProjectType.value = Number(res.Grade) === accountRequestData.officeRole ? 'office' : 'community';
                // 6.5.2 pm操作个人设备的权限控制(仅新社区实现)
                community.hasHaveAccessArea.value = (
                    community.ProjectType.value === 'community' && res.IsNew === '1'
                ) ? res.IsHaveAccessArea === 1 : true;
                ChangeTextByScene(community.ProjectType.value);
                // 办公隐藏subscription入口
                if (community.ProjectType.value === 'office') {
                    menus.value = getMenuList(1, community.ProjectType.value);
                } else {
                    community.getPropertyCommunityChargeMode((data: { ChargeMode: string | number }) => {
                        community.ChargeMode.value = data.ChargeMode as number;
                        menus.value = getMenuList(data.ChargeMode, community.ProjectType.value);
                    });
                }
                if (res.SmartHomeUUID !== undefined) {
                    community.smartHomeUUID.value = res.SmartHomeUUID;
                } else {
                    // 清楚上次影响
                    community.smartHomeUUID.value = false;
                }
                community.isNew.value = res.IsNew === '1';
                if (community.isNew.value && community.ProjectType.value === 'community') {
                    initImportFaceTipData();
                    getImportDetails();
                    getImportResidentDetail();
                    pmCommonApi.getUnReadLogNum((alert: {
                        Number: number;
                    }) => {
                        community.alertCount.value = Number(alert.Number);
                    });
                } else {
                    // v6.5 初始化导入人脸请求数据  2022/08/01 zyc
                    initImportFaceTipData();
                }
            });
        };
        getProjectDetail();

        const account = String(localStorage.getItem('userName'));

        // 右上角name下拉对话框
        const isShowPasswordDialog = ref(false);
        const isShowBillingDialog = ref(false);
        const isShowLinkSiteDialog = ref(false);
        const isShowLinkSucceedDialog = ref(false);
        const isShowDocumentDialog = ref(false);
        const chooseOpera = (key: string) => {
            hideAllPop();
            switch (key) {
                case 'password':
                    isShowPasswordDialog.value = true;
                    break;
                case 'bill':
                    isShowBillingDialog.value = true;
                    break;
                case 'link-site':
                    isShowLinkSiteDialog.value = true;
                    break;
                case 'knowledgeBase':
                    window.open('https://knowledge.akuvox.com/');
                    break;
                default:
                    break;
            }
        };

        const changeCommunity = (communityID: string) => {
            hideAllPop();
            localStorage.setItem('communityID', communityID);
            activeCommunity.ID = communityID;
            communityList.forEach((item) => {
                if (item.key === communityID) {
                    activeCommunity.label = item.label;
                }
            });
            getProjectDetail();
            router.push(`/${propertyBaseRouter}/${propertySubRouter.black}`);
        };
        const emergencyActionDialogRef = ref();
        function openEmergencyAction() {
            emergencyActionDialogRef.value.dialogVisible = true;
        }

        // 跳转Alarm记录页面
        function toAlarm() {
            router.push(`/${propertyBaseRouter}/${propertySubRouter.alarmRecoeds}`);
        }

        return {
            menus,
            userOperaList,
            chooseOpera,
            changeCommunity,
            account,
            isShowPasswordDialog,
            isShowBillingDialog,
            isShowLinkSiteDialog,
            isShowLinkSucceedDialog,
            isShowDocumentDialog,
            fileList,
            communityList,
            activeCommunity,
            propertyBaseRouter,
            propertySubRouter,
            hideOtherPop,
            controlPopVal,
            isShowImportFaceTip,
            dealImportDetails,
            closeImportFaceTip,
            openEmergencyAction,
            emergencyActionDialogRef,
            community,
            toAlarm,
            goBackLogin
        };
    }
});
